(() => {
  if (window.TDFWMobileNavigation) return;
  window.TDFWMobileNavigation = true;
  let cartCount = null, pending = false, queued = false, timer, observer, jqueryBound = false;
  function update(selector, count) {
    if (count == null || !Number.isFinite(Number(count))) return;
    const value = Math.max(0, Math.floor(Number(count)));
    document.querySelectorAll(selector).forEach(el => {
      if (el.textContent !== String(value)) el.textContent = String(value);
      el.hidden = value === 0;
    });
  }
  function setCart(count) {
    if (count == null || !Number.isFinite(Number(count))) return;
    cartCount = Number(count);
    update('[data-mobile-cart-count]', cartCount);
  }
  function wishlist() {
    try {
      const items = window.TDFWWishlist?.get?.() ?? JSON.parse(localStorage.getItem('tdfw_wishlist') || '[]');
      update('[data-wishlist-count]', Array.isArray(items) ? items.length : 0);
    } catch (_) { update('[data-wishlist-count]', 0); }
  }
  async function fetchCart() {
    if (pending) { queued = true; return; }
    pending = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root.replace(/\/?$/, '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      setCart(cart.item_count);
    } catch (_) { /* Retain the server-rendered count if the request fails. */ }
    finally { pending = false; if (queued) { queued = false; schedule(); } }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(fetchCart, 150); }
  function bindJquery() {
    if (jqueryBound || !window.jQuery) return;
    jqueryBound = true;
    window.jQuery(document).on('ajaxComplete.tdfwMobileCounts', (_event, xhr, settings) => {
      const url = new URL(settings.url || '', location.origin);
      if (url.origin !== location.origin || !/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname)) return;
      if (xhr.status < 200 || xhr.status >= 300) return;
      const cart = xhr.responseJSON;
      if (cart?.item_count != null) setCart(cart.item_count);
      schedule();
    });
  }
  function init() {
    wishlist();
    if (cartCount !== null) update('[data-mobile-cart-count]', cartCount);
    bindJquery();
    observer?.disconnect();
    const header = document.querySelector('.header-group');
    if (header) {
      observer = new MutationObserver(() => {
        const count = header.querySelector(
  '.header-cart .header-cart__count:not([data-wishlist-count])'
);
        if (count && /^\d+$/.test(count.textContent.trim())) setCart(count.textContent.trim());
      });
      observer.observe(header, { childList: true, subtree: true, characterData: true });
    }
    schedule();
  }
  document.addEventListener('wishlist:updated', wishlist);
  document.addEventListener('cart:updated', e => {
    setCart(e.detail?.cart?.item_count ?? e.detail?.item_count);
    schedule();
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', e => { if (e.key === 'tdfw_wishlist' || e.key === null) wishlist(); });
  window.addEventListener('pageshow', () => { wishlist(); bindJquery(); schedule(); });
  window.addEventListener('focus', () => { wishlist(); schedule(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
